export const UIModalZIndex = 1000;
export const UISelectDropDownZIndex = 1001;
